import { render, staticRenderFns } from "./stay-tax.vue?vue&type=template&id=276aff7a&"
import script from "./stay-tax.vue?vue&type=script&lang=js&"
export * from "./stay-tax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports